module.exports = __webpack_public_path__ + "static/media/mrPayBanner.9459f6bf.jpg";